import React from 'react';

import { AlertMsgContainer, Message, MessageContainer, Icon } from './styles';

import { ReactComponent as Alert } from '../../../assets/novosicones/Solicitacoes/icon alert (2).svg';
const AlertMessage = ({
  children,
  onSelectSolicitacao,
  idSolicitacao,
  alertTitle,
  alertText,
}) => {
  const handleClick = () => {
    if (idSolicitacao) onSelectSolicitacao(idSolicitacao);
  };

  return (
    <AlertMsgContainer
      onClick={() => {
        handleClick();
      }}
    >
      <Icon className='centralized'>
        <div>
          <Alert />
        </div>
        <span>atenção</span>
      </Icon>
      <MessageContainer>
        <Message
          font={'14px'}
          messageColor={'#be2f25'}
          id={'txtNaoFoiPossivelIniciarSolicitacao'}
        >
          {alertTitle
            ? alertTitle
            : `Não foi possível iniciar sua solicitação!`}
        </Message>

        <Message font={'10px'} messageColor={'#4d4d4d'} marginTop={'4px'}>
          {alertText ? alertText : children}
        </Message>
      </MessageContainer>
    </AlertMsgContainer>
  );
};

export default AlertMessage;
